import request from '@/utils/request'

// 查询保证金列表
export function queryAccountBond(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/accountBond.queryAccountBond',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询店铺类型
export function queryShopType(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopType.queryShopType',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加保证金
export function saveAccountBond(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/accountBond.saveAccountBond',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新保证金
export function updateAccountBond(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/accountBond.updateAccountBond',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除保证金
export function deleteAccountBond(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/accountBond.deleteAccountBond',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}